import { Component, Input, Output, OnInit, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ReceiptSections, ReceiptConfigEnum } from 'src/app/features/settings/models/receipt';
import { CheckOutService } from '../check-out/CheckOut.service';

@Component({
  selector: 'app-receipt',
  // changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './receipt.component.html'
})
export class ReceiptComponent implements OnInit {
  loading = false;
  @Input() sections!: ReceiptSections[];
  @Input() logo!: string;
  @Input() resDetails!: any;

  @Input() orderId!: number;
  @Input() checkOutId!: number;

  @Output() isReady = new EventEmitter();

  config: any = {}
  orderDetails: any = {
    restaurantName: 'Karam Beirut',
    restaurantAddress: 'Bin Awwal، Prince Turki Ibn Abdulaziz Al Awwal Rd, Al Mohammadiyyah, Riyadh 11564',
    orderNumber: 18567,
    tableName: 'D-54',
    waiterName: 'Ahmed Samir',
    customerName: 'Omar Tarek',
    partySize: 3,
    orderId: 1238,
    subTotal: 500,
    serviceValue: 0,
    taxValue: 0,
    discountName: '',
    discountValue: 500,
    surchargeValue: 10,
    total: 500,
    currency: {},
    restaurantVatNumber: '11.111.111/0001-55',
    reciptQrCode: '',
    orderItems: [
      {
        itemName: 'Grilled Jumbo Shrimps',
        sizeName: 'Regular',
        quantity: 1,
        price: 77,
        totalItemprice: 77,
      },
      {
        itemName: 'Grilled Jumbo Shrimps',
        sizeName: 'Regular',
        quantity: 1,
        price: 77,
        totalItemprice: 77,
      },
    ]
  };
  paymentDetails = {
    priceAmount: 9.25,
    paidPrice: 290,
    remainAmount: 0.75,
    tipsValue: 0.75,
    checkOutType: 'SplitPrice',
    paymentOption: 'Cash',
    paymentOptionName: 'Cash',
    cardLastNumbers: '',
    isPortion: true,
    reservationOrderSelectedItems: null,
    canAddTip: false,
    isPaid: true,
    paidAt: new Date(),
    priceDetails: {
      subTotal: 500,
      serviceValue: 10,
      taxValue: 0,
      discountName: '',
      discountValue: 500,
      surchargeValue: 10,
      total: 500,
      deposit: 0
    }
  };

  constructor(
    private service: CheckOutService
  ) { }

  ngOnInit(): void {
    if (this.sections) {
      this.setConfig();
      this.orderDetails.restaurantName = this.resDetails.restaurantName
      this.orderDetails.restaurantAddress = this.resDetails.restaurantAddress
    } else if (this.orderId) {
      this.callPrinting();
    }
  }

  setConfig() {
    this.sections.forEach(section => {
      section.receiptFields.forEach(element => {
        this.config[element.lookUpCode] = {}
        this.config[element.lookUpCode].isActive = element.isActive
        this.config[element.lookUpCode].value = element.fieldValue
      })
    });
  }

  callPrinting() {
    if (localStorage.getItem('deviceId')) {
      this.MobileRecipt();
    } else {
      this.getReceiptConfgDetails();
    }
  }

  getReceiptConfgDetails() {
    this.loading = true;
    this.service.ResGetCheckOutRecipt(this.orderId, this.checkOutId).subscribe((data: any) => {
      this.orderDetails = data.orderDetails;
      this.paymentDetails = data.paymentDetails;
      this.sections = data.receiptConfig;
      this.setConfig();
      this.loading = false;
      setTimeout(() => { this.print(data.htmlContent); }, 1000);
    })
  }
  MobileRecipt() {
    this.loading = true;
    let data: any = {
      OrderId: this.orderId,
      deviceId: localStorage.getItem('deviceId'),
      deviceType: localStorage.getItem('deviceType'),
    };
    // if (this.checkOutId) {
    //   data.CheckOutId = this.checkOutId;
    // }
    this.service.prentrest(data).subscribe(data => {
      this.loading = false;
      this.isReady.emit(true);
    }, err => {
      this.loading = false;
      this.isReady.emit(true);
    });
  }

  getField(code: ReceiptConfigEnum) {
    let field: any;
    this.sections.forEach((section: any) => {
      if (!field) {
        section.receiptFields.forEach((element: any) => {
          if (!field) {
            if (element.lookUpCode == code) {
              field = element;
            }
          }
        });
      }
    });
    return field;
  }

  print(html: string): void {
    const basicUrl = location.origin;
    let style = basicUrl + '/assets/scss/print.css';
    let dir = 'rtl';
    const mywindow: any = window.open('', 'PRINT', 'height=1000,width=700');
    mywindow.document.write(html);
    // mywindow.document.write('<html dir="' + dir + '" lang="ar"><head>\
    //   <base href="/">\
    //   <meta charset="UTF-8">\
    //   <meta name="viewport" content="width=device-width, initial-scale=1.0">\
    //   <meta http-equiv="X-UA-Compatible" content="ie=edge">\
    //   <link rel="stylesheet" type="text/css" href="' + style + '">\
    //   <title>' + document.title + '</title>');
    // mywindow.document.write('</head><body>');
    // mywindow.document.write(document.getElementById("reciept-print")?.innerHTML);
    // mywindow.document.write('</body></html>');
    this.isReady.emit(true)

    mywindow.document.close();
    mywindow.focus();

    mywindow.onload = () => {
      mywindow.print();
    };
  }
}
